module.exports = __webpack_public_path__ + "img/小朋友.b13d3435.png";